import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClerkProvider } from "@clerk/react";
import { dark } from "@clerk/ui/themes";
import { useHtmlTheme } from "../../lib/theme";

const LIGHT = {
  captcha: { theme: "light" },
  variables: {
    colorPrimary: "#B08A1A",
    colorPrimaryForeground: "#FFFFFF",
    colorBackground: "#FFFFFF",
    colorForeground: "#14161c",
    colorInput: "#FFFFFF",
    colorInputForeground: "#14161c",
    colorBorder: "rgba(140,105,18,0.45)",
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    borderRadius: "0.6rem",
  },
};

const appearance = {
  theme: dark,
  captcha: { theme: "dark" },
  variables: {
    colorPrimary: "#D4AF37",
    colorPrimaryForeground: "#08090C",
    colorBackground: "#111319",
    colorForeground: "#F8F9FA",
    colorInput: "#161922",
    colorInputForeground: "#F8F9FA",
    colorBorder: "rgba(212,175,55,0.25)",
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    borderRadius: "0.6rem",
  },
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function ClerkAuthProvider({ children }) {
  const navigate = useNavigate();
  const mode = useHtmlTheme();
  const [config, setConfig] = useState(null);
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = async (attempt = 0) => {
      try {
        const cfg = await (await fetch(`${BACKEND_URL}/api/clerk/config`)).json();
        if (cfg.enabled) return cancelled || setConfig(cfg);
      } catch {}
      if (cancelled) return;
      if (attempt >= 20) return setUnavailable(true);
      setTimeout(() => load(attempt + 1), 1500);
    };
    load();
    return () => { cancelled = true; };
  }, []);

  if (unavailable) return <p style={{ padding: 24 }}>Sign-in is unavailable right now. Refresh the page to try again.</p>;
  if (!config) return null;
  return (
    <ClerkProvider
      publishableKey={config.publishable_key}
      proxyUrl={config.proxy_url || undefined}
      appearance={mode === "light" ? LIGHT : appearance}
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
      signInFallbackRedirectUrl="/"
      signUpFallbackRedirectUrl="/"
      afterSignOutUrl="/"
    >
      {children}
    </ClerkProvider>
  );
}
